import React, { Suspense, lazy } from 'react';
import { FullScreenSpin } from 'components/Spin';

const PromoComponent = lazy(() => import('features/Promo'));

const PromoPage = () => {
  return (
    <Suspense fallback={<FullScreenSpin />}>
      <PromoComponent />
    </Suspense>
  );
};

export default PromoPage;
